import React from 'react';
import useDateUtils from 'src/utils/date/useDateUtils';
import Typography from '../typography/Typography';
const FormattedDate = ({ mode, date, ...typographyProps }) => {
    const dateUtils = useDateUtils();
    const toDisplay = dateUtils.getReadableDate(date, mode);
    return React.createElement(Typography, { ...typographyProps }, toDisplay);
};
export default FormattedDate;
